/* theme.js — Vitamynx Liquid Theme
 * Global motion primitives + Web Component bootstrap.
 *
 * Rules:
 *   - No innerHTML = string anywhere.
 *   - All DOM mutations go through createElement / appendChild / setAttribute.
 *   - Web Components own their own JS; this file only bootstraps globals.
 */
(function () {
  'use strict';

  // ────────────────────────────────────────────────────────────────────
  // Scroll-reveal primitive — opt-in via class="vmx-reveal".
  // Honors prefers-reduced-motion (CSS short-circuits the transition).
  // Stagger children inside a group: parent class="vmx-reveal-group"
  // data-vmx-reveal-stagger="50" — each child auto-gets its delay.
  // ────────────────────────────────────────────────────────────────────
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.vmx-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    document.querySelectorAll('[data-vmx-reveal-group]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-vmx-reveal-stagger') || '0', 10);
      if (!step) return;
      var kids = group.querySelectorAll('.vmx-reveal');
      kids.forEach(function (kid, i) {
        if (!kid.style.getPropertyValue('--vmx-reveal-delay')) {
          kid.style.setProperty('--vmx-reveal-delay', (i * step) + 'ms');
        }
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-40px 0px -10% 0px', threshold: 0.01 });

    document.querySelectorAll('.vmx-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Phase 2+: vmx-header.js, vmx-nav-drawer.js registrations
  // Phase 4+: vmx-cart-drawer.js registration
  // Phase 5+: vmx-add-to-cart.js, vmx-pdp-gallery.js registration
})();
